"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmountPresentationModeControls = exports.mountPresentationModeControls = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var MOUNT_POINT_ID = "presentation-controls-mount-point";
var c = (0, BemBuilder_1.default)("presentation-controls");
function PresentationModeControls(props) {
    return (react_1.default.createElement(kaleidoscope_1.Panel, { className: c("exit-fullscreen"), elevation: 1 },
        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: react_1.default.createElement(react_1.default.Fragment, null,
                "Exit Presentation",
                " ",
                react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, theme: "dark" }, "esc")), position: kaleidoscope_1.TooltipPosition.Left, autoStack: false },
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ExitFullScreen, null), onClick: props.onExitClick, "aria-label": "Exit fullscreen", size: kaleidoscope_1.ButtonSize.Small }))));
}
function mountPresentationModeControls(props) {
    var mountPoint = document.getElementById(MOUNT_POINT_ID);
    if (!mountPoint)
        return;
    (0, react_dom_1.render)(react_1.default.createElement(PresentationModeControls, __assign({}, props)), mountPoint);
}
exports.mountPresentationModeControls = mountPresentationModeControls;
function unmountPresentationModeControls() {
    var mountPoint = document.getElementById(MOUNT_POINT_ID);
    if (!mountPoint)
        return;
    (0, react_dom_1.unmountComponentAtNode)(mountPoint);
}
exports.unmountPresentationModeControls = unmountPresentationModeControls;
